export default "__VITE_ASSET__xWSpNN8a__"